import { Component, inject, InjectionToken } from '@angular/core';
import { ActionTypeLabel } from '@fullyops/data/action-types/entities/action-type-entity';
import { SidePanelComponent } from '@fullyops/shared/components/side-panel/side-panel.component';
import { I18NextCapPipe } from 'angular-i18next';
import { MaterialModule } from '@fullyops/shared/material.module';
import {
  CreateEquipmentPanelComponent,
  CreatedEquipment,
} from '../create-equipment-panel/create-equipment-panel.component';

export interface NewEquipmentSidebarInputs {
  /** The company to assign the new equipment to, or null to leave it unassigned. */
  companyId: string | null;
  /** The company is the context's own, as on a company's page; see `CreateEquipmentPanelComponent.lockCompany`. */
  lockCompany?: boolean;
  /** Only asset types compatible with this action type are offered; null offers every type. */
  actionType: ActionTypeLabel | null;
  /** Opened on top of another panel, which it goes back to. */
  nested: boolean;
  onSave(created: CreatedEquipment): void;
  onCancel(): void;
}

export const NEW_EQUIPMENT_SIDEBAR_TOKEN =
  new InjectionToken<NewEquipmentSidebarInputs>('new-equipment-sidebar-inputs');

/** The sidebar frame around the equipment creation panel. */
@Component({
  selector: 'fo-new-equipment-sidebar',
  templateUrl: './new-equipment-sidebar.component.html',
  styleUrl: './new-equipment-sidebar.component.scss',
  imports: [
    SidePanelComponent,
    I18NextCapPipe,
    MaterialModule,
    CreateEquipmentPanelComponent,
  ],
})
export class NewEquipmentSidebarComponent {
  protected inputs = inject(NEW_EQUIPMENT_SIDEBAR_TOKEN);
}
